/**
 * 日志类.
 *
 * @author  yusangeng@outlook.com
 */
import { __spreadArray } from "tslib";
import Path from "./Path";
import Filter, { Level } from "./Filter";
import Driver from "./Driver";
import config from "./config";
var assign = Object.assign;
// 默认模块名(同时表示全局)
var globalModuleName = "global";
/**
 * 日志类.
 *
 * @export
 * @class Logger
 */
var Logger = /** @class */ (function () {
    function Logger(moduleName, conf) {
        var _this = this;
        this.debug = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return _this.printByLevel.apply(_this, __spreadArray([Level.DEBUG], params, false));
        };
        this.info = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return _this.printByLevel.apply(_this, __spreadArray([Level.INFO], params, false));
        };
        this.warn = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return _this.printByLevel.apply(_this, __spreadArray([Level.WARN], params, false));
        };
        this.error = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return _this.printByLevel.apply(_this, __spreadArray([Level.ERROR], params, false));
        };
        this.print = function () {
            var _a;
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            (_a = _this.driver.log).call.apply(_a, __spreadArray([_this.driver,
                Level.TEST,
                _this.moduleName.toString()], params, false));
        };
        this.moduleName = new Path(moduleName || globalModuleName);
        var _a = Logger.injector.getClasses(), Driver = _a[0], Filter = _a[1];
        var cf = assign({}, config, conf);
        this.driver = new Driver(cf);
        this.filter = new Filter(cf);
    }
    Logger.prototype.printByLevel = function (level) {
        var _a;
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        if (!this.filter.exec(level, this.moduleName)) {
            return false;
        }
        (_a = this.driver.log).call.apply(_a, __spreadArray([this.driver,
            level,
            this.moduleName.toString()], params, false));
        return true;
    };
    Logger.injector = new (/** @class */ (function () {
        function DefaultInjector() {
            this.Driver = Driver;
            this.Filter = Filter;
        }
        DefaultInjector.prototype.getClasses = function () {
            var _a = this, Driver = _a.Driver, Filter = _a.Filter;
            if (!Driver || !Filter) {
                throw new TypeError("Either class Driver or class Filter should be injected.");
            }
            return [Driver, Filter];
        };
        return DefaultInjector;
    }()))();
    return Logger;
}());
export default Logger;
//# sourceMappingURL=data:application/json;base64,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